<template>
  <div>
    <div class="px-3 md:px-10">
      <h2 class="font-bold text-lg mt-3">ČR se připravuje.</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "Czech",
  components: {}
};
</script>

<style></style>
